<script>
  import { I18n } from "i18n-js"
  import i18n_translations from "../../../javascript/locales.json"
  import profilePic from '../../../javascript/images/modules/translations/index/me.webp'
  import profilePic2x from '../../../javascript/images/modules/translations/index/me@2x.webp'

  let { RailsApp } = $props()

  const i18n = new I18n(i18n_translations)
  i18n.locale = RailsApp.I18n.locale

  const profileImage = {
    src: profilePic,
    srcset: `${profilePic} 1x, ${profilePic2x} 2x`
  }

  const links = [
    {
      icon: 'bi-envelope-open',
      url: 'mailto:felixding@gmail.com',
      text: 'Email',
    },
    {
      icon: 'bi-house',
      url: 'https://dingyu.me',
      text: 'Homepage',
    },
    {
      icon: 'bi-linkedin',
      url: 'https://www.linkedin.com/in/felixding/',
      text: 'LinkedIn',
    },
    {
      icon: 'bi-github',
      url: 'https://github.com/felixding/',
      text: 'GitHub',
    },
    {
      icon: 'bi-twitter-x',
      url: 'https://x.com/felixding_',
      text: 'Twitter / X',
    },
    {
      icon: 'bi-instagram',
      url: 'https://www.instagram.com/felixding/',
      text: 'Instagram',
    },
  ]
</script>

<section id="about" class="pt-5 pb-5">
  <div class="container">
    <h2 class="text-black fw-normal text-center mb-5">
      {i18n.t("Translations.Index.sections.about.title")}
    </h2>
    <div class="row">
      <div class="col-12 col-md-4 mb-2 mb-md-0">
        <img src={profileImage.src}
             srcset={profileImage.srcset}
             class="img-fluid"
             alt="Ding Yu" />
      </div>
      <div class="col-12 col-md-8">
        <p>{i18n.t("Translations.Index.sections.about.intro_1")}</p>
        <p>{i18n.t("Translations.Index.sections.about.intro_2")}</p>
        <p>{i18n.t("Translations.Index.sections.about.intro_3")}</p>

        {#each links as link}
          <a aria-label="{link.text}" href={link.url} class="me-3" target="_blank" rel="noopener noreferrer">
            <i class="bi {link.icon}"></i>
          </a>
        {/each}
      </div>
    </div>
  </div>
</section>
